import { DefaultSearchType } from 'algolia-api/types/DefaultSearchType';
import { DisplayedType } from 'algolia-api/types/DisplayedTypes';
import { ListingType } from 'algolia-api/types/ListingType';
import { SearchLocation } from 'algolia-api/types/SearchLocation';
import { Button } from 'components/Button/Button';
import { H4 } from 'components/Text/H4';
import { colors } from 'theme/theme';

import {
  MobileSearchMenuContainer,
  MobileSearchMenuHeader,
  MobileSearchMenuWrapper,
} from './StaffMobileSearchMenu.styled';
import { StaffPageHeaderSearchInputs } from './StaffPageHeaderSearchInputs';

type Props = {
  onClose: () => void;
  onSearch: () => void;
  searchOpen: boolean;
  selectedType: DisplayedType;
  listingTypes: DisplayedType[];
  clearSearchInput: () => void;
  initialQuery: string;
  query: string;
  onLocationChange: (arg0: SearchLocation | null | undefined) => void;
  setListingType: (listingType: ListingType | DefaultSearchType) => void;
  search: (query: string) => void;
  searchLocation: SearchLocation | undefined;
  setUserQuery: (q: string) => void;
};

export function StaffMobileSearchMenu({
  onClose,
  onSearch,
  searchOpen,
  selectedType,
  listingTypes,
  clearSearchInput,
  initialQuery,
  query,
  onLocationChange,
  setListingType,
  search,
  searchLocation,
  setUserQuery,
}: Props) {
  return (
    <MobileSearchMenuContainer
      $open={searchOpen}
      data-qa-id="mobile-search-menu"
    >
      <MobileSearchMenuHeader>
        <H4 mb={0} color={colors.brandBlue}>
          {getText('Search')}
        </H4>
        <Button
          data-qa-id="close-mobile-search"
          onClick={onClose}
          aria-label={getText('Close search')}
          variant="tertiary"
          noPadding
          icon={{ type: 'normalized', name: 'close' }}
        />
      </MobileSearchMenuHeader>

      <MobileSearchMenuWrapper>
        <StaffPageHeaderSearchInputs
          onSearch={onSearch}
          selectedType={selectedType}
          listingTypes={listingTypes}
          clearSearchInput={clearSearchInput}
          search={search}
          initialQuery={initialQuery}
          query={query}
          searchLocation={searchLocation}
          setListingType={setListingType}
          setQuery={setUserQuery}
          onLocationChange={onLocationChange}
          searchInputId="mobile-search-query"
          searchInputQaId="mobile-search-input"
        />
      </MobileSearchMenuWrapper>
    </MobileSearchMenuContainer>
  );
}
